document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".btn_cats_toggle").forEach(function (toggleBtn) {
    toggleBtn.addEventListener("click", function (e) {
      e.preventDefault();

      let parent = toggleBtn.closest("li.pr.menu_nested");
      let submenu = parent.querySelector(".sub-menu");

      if (!submenu) return;

      // Toggle class
      submenu.classList.toggle("dn");
      toggleBtn.classList.toggle("active");
    });
  });
});